import { render, staticRenderFns } from "./ReviewComments.vue?vue&type=template&id=5d560fe0&scoped=true&"
import script from "./ReviewComments.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewComments.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewComments.vue?vue&type=style&index=0&id=5d560fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d560fe0",
  null
  
)

export default component.exports